/**
 * MNR-777: Theme -> SalesBot-Events (Magnamate).
 *
 * Meldet dem Chat-Widget zwei Ereignisse, jeweils NUR für Modals, die der
 * Chatbot selbst geöffnet hat (Entscheidung Yojia/Nolan):
 *   cart.item_added          — Add-to-Cart im Modal erfolgreich
 *   product_modal.abandoned  — Modal ohne Add geschlossen
 *
 * Vendor-API: window.magnamateWidget.notify({ event, source?, data }).
 * Künftige Events sind neue `event`-Namen auf derselben Funktion.
 * Doku: "Storefront Event Notifications for the Magnamate Widget", 18.08.2026.
 *
 * Ohne laufende Unterhaltung, ohne Consent oder ohne im Magnamate-Dashboard
 * aktiviertes Feature passiert nichts — sehen die Aufrufe korrekt aus, geht aber
 * kein Request raus, dort prüfen lassen.
 *
 * Console-Test:
 *   window.magnamateWidget.notify({event:'cart.item_added',data:{productId:'10274209267876',variantId:'51137623130384',quantity:1,title:'Chunky Flavour'}});
 *   window.magnamateWidget.notify({event:'product_modal.abandoned',data:{}});
 */
(function () {
  if (window.__mnrSalesAgentEventsInit) return;
  window.__mnrSalesAgentEventsInit = true;

  var WIDGET_FN = 'notify';
  var WIDGET_MODAL_ID = 'QuickAdd-external';
  var PENDING_TIMEOUT_MS = 10000;

  // Einziger Ort mit Vendor-Details — ändert Nolan Namen oder Felder, nur hier anpassen.
  var EVENTS = {
    addToCart: {
      event: 'cart.item_added',
      build: function (d) {
        return { productId: d.productId, variantId: d.variantId, quantity: d.quantity, title: d.title };
      },
    },
    modalAbandoned: {
      event: 'product_modal.abandoned',
      // Leer: das Widget hat das Modal geöffnet und kennt das Produkt bereits.
      build: function () {
        return {};
      },
    },
  };

  var missingWidgetWarned = false;

  function isNumericId(value) {
    return /^\d+$/.test(String(value));
  }

  function emit(eventKey, data, source) {
    var spec = EVENTS[eventKey];
    if (!spec) return;

    var widget = window.magnamateWidget;

    if (!widget || typeof widget[WIDGET_FN] !== 'function') {
      if (!missingWidgetWarned) {
        missingWidgetWarned = true;
        console.warn('Sales Agent Events: magnamateWidget.' + WIDGET_FN + '() nicht verfügbar — Event verworfen.');
      }
      return;
    }

    var payload = { event: spec.event, data: spec.build(data) };
    if (source) payload.source = source;

    try {
      widget[WIDGET_FN](payload);
    } catch (e) {
      // Subscriber laufen im Promise.all von pubsub.js — ein Throw aus dem
      // Fremd-Widget würde die Post-Add-Kette in product-form.js mitreißen.
      console.error('Sales Agent Events: ' + spec.event + ' failed:', e);
    }
  }

  // ── Add-to-Cart ────────────────────────────────────────────────────────────

  /**
   * Pfand-Zeilen sind kein empfehlbares Produkt. Drei Marker nötig, weil je nach
   * Pfad ein anderer vorliegt: parent_id (product-form), _is_deposit (depositSync)
   * und die _deposit_variant-Referenz der Parent-Line — depositSync() setzt
   * _is_deposit erst NACH dem addToCartSuccess-Publish, und der bundle-add-Pfad
   * liefert gar keine parent_id.
   */
  function isDepositLine(line, allLines) {
    var props = (line.cartItem && line.cartItem.properties) || {};
    if (props._is_deposit === 'true' || props._is_deposit === true) return true;
    if (line.requestItem && line.requestItem.parent_id) return true;

    var variantId = line.cartItem && line.cartItem.variant_id;
    if (!variantId || !Array.isArray(allLines)) return false;

    return allLines.some(function (other) {
      if (other === line) return false;
      var otherProps = (other.cartItem && other.cartItem.properties) || {};
      return String(otherProps._deposit_variant || '') === String(variantId);
    });
  }

  /**
   * Das Quick-Add-Modal, aus dem dieser Add kam — oder null.
   *
   * Selbst aufgelöst statt über eine Markierung im Payload: das
   * addToCartSuccess-Objekt teilen sich alle Subscriber (pubsub.js reicht
   * dieselbe Referenz weiter), eine Markierung wäre also von deren
   * Registrierungsreihenfolge abhängig.
   */
  function modalForAdd(e) {
    if (e.formId) {
      // getElementById statt querySelector: eine formId mit Anführungszeichen
      // wäre als CSS-Selektor ein SyntaxError.
      var form = document.getElementById(e.formId);
      var modal = form && form.closest ? form.closest('quick-add-modal') : null;
      if (modal) return modal;
    }

    // Gift-Adds schicken ein Objekt-Literal statt eines DOM-Knotens.
    var submitter = e.atcSubmitter || e.submitter;
    if (submitter && submitter.nodeType === 1 && submitter.closest) {
      return submitter.closest('quick-add-modal');
    }

    return null;
  }

  function handleAddToCartSuccess(e) {
    var modal = modalForAdd(e);

    // Session als "gekauft" markieren, damit das Schließen danach kein
    // Abandonment auslöst.
    if (modal) {
      modal._addSucceeded = true;
      modal._addPending = false;
      clearTimeout(modal._addPendingTimer);
    }

    // Zum Zurückdrehen auf "jeder erfolgreiche Add" (so Ticket und Vendor-Doku):
    // diese Bedingung entfernen.
    if (!modal || modal.id !== WIDGET_MODAL_ID) return;

    // Ohne formData/requestItems liefert der Resolver ALLE Cart-Lines
    // (z. B. octane-atc.liquid publisht so) — der Bot bewürbe dann ein
    // beliebiges, längst im Warenkorb liegendes Produkt. Bitte nicht "aufräumen".
    var hasFormData = e.source === 'product-form' && e.formData;
    var hasRequestItems = Array.isArray(e.requestItems) && e.requestItems.length > 0;
    if (!hasFormData && !hasRequestItems) return;

    var resolver = window.MNRCartLines;
    if (!resolver || typeof resolver.getAddedLinesFromPayload !== 'function') {
      console.warn('Sales Agent Events: window.MNRCartLines fehlt (cart-added-lines.js nicht geladen?).');
      return;
    }

    var allLines = resolver.getAddedLinesFromPayload(e);
    var lines = allLines.filter(function (line) {
      return line && line.cartItem && !isDepositLine(line, allLines);
    });

    if (!lines.length) return;

    // Nur ein Call: das Widget dedupliziert nur dieselbe Variante innerhalb von
    // 10s, verschiedene Varianten ergäben N Chat-Nachrichten. items[0] ist per
    // Konstruktion das Hauptprodukt, Cross-Sells hängen dahinter.
    var line = lines[0];
    var cartItem = line.cartItem;

    if (!isNumericId(cartItem.product_id)) {
      console.warn('Sales Agent Events: product_id nicht numerisch, Event verworfen:', cartItem.product_id);
      return;
    }

    emit(
      'addToCart',
      {
        productId: String(cartItem.product_id),
        variantId: String(cartItem.variant_id),
        // line.quantity ist der geclampte Request-Wert; cartItem.quantity wäre
        // die kumulierte Line-Menge nach einem Repeat-Add.
        quantity: Number(line.quantity),
        title: cartItem.product_title || '',
      },
      e.source || 'product-form'
    );
  }

  // ── Modal ohne Add verlassen ───────────────────────────────────────────────

  function handleCloseQuickAdd(event) {
    if (!event || event.source !== 'quick-add') return;
    if (event.modalId !== WIDGET_MODAL_ID) return;
    if (event.addSucceeded) return;

    // Add noch unterwegs: der Close kam vor der Antwort von /cart/add.js. Ohne
    // diesen Guard bekäme der Kunde ein "war doch nicht das Richtige?" für einen
    // Kauf, der gleich durchgeht.
    var modal = document.getElementById(WIDGET_MODAL_ID);
    if (modal && modal._addPending) return;

    emit('modalAbandoned', {}, 'quick-add-modal');
  }

  // subscribe() erst ab DOMContentLoaded: constants.js und pubsub.js werden in
  // theme.liquid nach tracking.js eingebunden. Gleiches Pattern wie tracking.js.
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('Sales Agent Events: PubSub nicht verfügbar — Events werden nicht gemeldet.');
      return;
    }

    // Capture, damit es vor product-form.js läuft: markiert das Modal als
    // "Add unterwegs", solange /cart/add.js noch nicht geantwortet hat.
    //
    // Das Flag läuft nach PENDING_TIMEOUT_MS von selbst ab. Nötig, weil nicht
    // jeder Fehlschlag ein cartError published — der .catch() in
    // product-form.js:173 loggt nur (Netzwerk-/JSON-Fehler). Ohne Ablauf bliebe
    // das Abandonment nach einem abgebrochenen Request bis zum nächsten show()
    // unterdrückt.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.dataset?.type !== 'add-to-cart-form') return;
        var modal = form.closest ? form.closest('quick-add-modal') : null;
        if (!modal) return;

        modal._addPending = true;
        clearTimeout(modal._addPendingTimer);
        modal._addPendingTimer = setTimeout(function () {
          modal._addPending = false;
        }, PENDING_TIMEOUT_MS);
      },
      true
    );

    // Kein addToCartSuccessSilent: Auto-Gifts hat der Kunde nicht angefordert.
    subscribe(PUB_SUB_EVENTS.addToCartSuccess, handleAddToCartSuccess);
    subscribe(PUB_SUB_EVENTS.closeQuickAdd, handleCloseQuickAdd);

    // Fehlgeschlagener Add: Pending-Flag räumen, sonst bliebe das Abandonment für
    // den Rest der Modal-Session unterdrückt. NICHT über modalForAdd() auflösen —
    // das cartError-Payload in product-form.js führt weder formId noch submitter.
    if (PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        var modal = document.getElementById(WIDGET_MODAL_ID);
        if (!modal) return;
        modal._addPending = false;
        clearTimeout(modal._addPendingTimer);
      });
    }
  });
})();
